import { gql } from '@apollo/client';

export interface ILibraryOpeningHoursException {
  id: string;
  name: string;
  date: string;
  opens: string;
  closes: string;
}
export const LibraryOpeningHoursExceptionsFragment = gql`
  fragment LibraryOpeningHoursExceptions on LibraryOpeningHoursException {
    sys {
      id
    }
    name
    date
    opens
    closes
  }
`;
